
import GuaranteeSection from "@/components/GuaranteeSection";

const Guarantee = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white">
      <GuaranteeSection />
    </div>
  );
};

export default Guarantee;
